import React, { useState, useEffect, useRef, useContext } from 'react';
import Chart from 'chart.js';
import {Button,Typography,Box} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { UserContext } from '../../../context/UserContext'
import ErrorMessage from "../../../common/ErrorMessage/ErrorMessage"
import { BASE_URL } from "../../../baseUrl"

const BarChartModalView = ({open, handleClose,id_client, id_strategy, desc_strategy, size}) => {

    const [login] = useContext(UserContext);
    const [errorMessage, setErrorMessage] = useState("");
    const [strategydata, setStrategyData] = useState([]);

    /*variable to draw the barchart*/
    const chartRef = useRef(null); // Add a ref for the chart canvas
    //const [validfromdate, setValidFromDate] = useState("");
    //const [validfrom, setValidFrom] = useState("");
    //const [validtodate, setValidToDate] = useState("");
    //const [validto, setValidTo] = useState("");
    const years_ = [];
    //const [linedata, setLineData] = useState([]);
    //const [linedataIDentry, setLineDataIDEntry] = useState([]);
    //const [barcolors, setBarColors] = useState([]);
    //const [yearlist, setYearList] = useState("");
    const listBars = [];

    const getStrategydata = async () => {
        const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + login.token,
        },
        };

        const response = await fetch(BASE_URL + `/api/bargraph/${id_client}/${id_strategy}`, requestOptions);
        if (!response.ok) {
            setErrorMessage("Something went wrong. Couldn't load the bargraph data");
        } else {
            const data = await response.json();
            console.log("************************")
            console.log("***strategy data*****")
            console.log(data)
            setStrategyData(data);         
        }
    };

    const drawbarchart = async() => {

        console.log('valid params')
        let validfromdate = strategydata[0].ValidFrom
        console.log(validfromdate)
        let validfrom = parseInt(validfromdate.split("-")[0])
        let validtodate = strategydata[0].ValidTo
        let validto = parseInt(validtodate.split("-")[0])
        console.log(validfrom)

        //setValidFromDate(strategydata[0].ValidFrom)
        //setValidFrom(parseInt(validfromdate.split("-")[0]))
        //setValidToDate(strategydata[0].ValidTo)
        //setValidTo(parseInt(validtodate.split("-")[0]))

        for (let i = validfrom; i <= validto; i++) {
            years_.push(i);
          }

        let linedata = Array(years_.length).fill(null)
        let linedataIDentry = Array(years_.length).fill(null)
        let barcolors = Array(years_.length).fill("rgba(54, 162, 235, 0.2)")
        
        //setYearList(years_.slice(years_.findIndex((index) => index >= validfrom)))
        let yearlist = years_.slice(years_.findIndex((index) => index >= validfrom))
        console.log("list of years")
        console.log(yearlist)

        // Calculate the new lineData from the fetched strategies
        linedata = years_.map(year => {
            const strategyForYear = strategydata.find(strategy => strategy.Year === year);
            return strategyForYear ? strategyForYear.Value : null;
        });

        //Calculate the new lineData "ID ENTRY" from strategies
        linedataIDentry = years_.map(year => {
            const strategyForYear_IDEntry = strategydata.find(strategy => strategy.Year === year);
            return strategyForYear_IDEntry ? strategyForYear_IDEntry.ID_DataEntry : null;
        });
        
        //return 2050 - Cyear;
        const YrstoEnd = () => {
            return validto-validfrom
        };
    
        const DivFactorBars = () => {
            return 1 / YrstoEnd();
        };
    
        const CYIndexLoc = () => {
            return years_.findIndex((index) => index >= validfrom);
        };
        
        let i = 0;
            while (i <= validto - validfrom) {
                const value = (i * DivFactorBars() * 100).toFixed(2);
                listBars.push(parseFloat(value));
                i++;
            }
        
        let chart;
        
        if (chartRef.current) {
            const ctx = chartRef.current.getContext("2d"); // Use the ref to get the chart canvas
        
            chart = new Chart(ctx, {
            type: "bar",
            data: {
                    labels: yearlist,
                    datasets: [
                      {
                        type: "bar",
                        label: "Expected Progress",
                        data: listBars,
                        backgroundColor: barcolors.slice(CYIndexLoc(validfrom)),
                        borderColor: "rgba(54, 162, 235, 1)",
                        borderWidth: 1,
                      },
                      {
                        fill: true,
                        type: "line",
                        label: "Progress Reported",
                        data: linedata,
                        borderColor: "rgba(255, 239, 109, 0.5)",
                      },
                    ],
                  },
        
                  /*options: {
                    onClick: function(evt, activeElements) {
                      if (activeElements.length === 0) return;
                      const firstPoint = this.getElementAtEvent(evt)[0];
                      if (firstPoint) {
                        const index = firstPoint._index;
                        const idEntry = linedataIDentry[CYIndexLoc(validfrom) + index]
        
                        if (idEntry !== null) {
                          const value = linedata[CYIndexLoc(validfrom) + index];
                          const year = years_[CYIndexLoc(validfrom) + index];
                          handleBarClick(year, value, idEntry);
                        }
                      }
                    }
                  }
                  */
        
            });
              
                chartRef.current.chart = chart; //Store the chart instance in the ref
              
        } else {
              window.scrollTo(0, 0);
        }
    }
    
    useEffect(() => {
        if (open) {
            getStrategydata();
        }
      }, [open, id_client, id_strategy]);

    useEffect(() => {
        if (strategydata.length>0) {
            console.log(strategydata.length)
            drawbarchart();
        }
    }, [strategydata]);

    return(
       <Dialog
            maxWidth={size} fullWidth
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    handleClose();
                }
            }}
            ModalProps={{disableEnforceFocus: true}}
            classes={{ paper: 'custom-dialog' }}
            PaperProps={{ style: { backgroundColor: '#231E39'}}}
        >
            <DialogTitle style={{color: 'white'}}>Currently Viewing: {desc_strategy}</DialogTitle>
            <DialogContent>   
                { (strategydata.length>0)? (
                    <canvas ref={chartRef} id="myChart" width="1800" height="900"></canvas>
                ) : (
                    <p>This strategy hasn't registered any progress yet!</p>
                )}
          
            </DialogContent>

            <DialogActions
                sx={{'& .MuiButton-text' : {color: 'var(--main-color)'}}}
            >
                <Button 
                    onClick={handleClose}
                    sx={{
                        paddingRight: '1.5rem',
                        marginRight: '1.5rem',
                        border: '1px solid var(--main-color)',
                
                }}>Close Barchart View</Button>
                
            </DialogActions>
 
       </Dialog> 
    )
}

export default BarChartModalView;